import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { BrandLogoComponent } from '../ui/brand-logo/brand-logo.component';

@Component({
  selector: 'app-footer',
  imports: [RouterModule, BrandLogoComponent, TranslatePipe],
  template: `
    <footer class="ap-footer">
      <div class="ap-wrap">
        <div class="ap-footer__top">
          <div class="ap-footer__brand">
            <a routerLink="/" class="ap-brand" [attr.aria-label]="'footer.homeAria' | translate">
              <app-brand-logo style="--brand-h: 26px" />
            </a>
            <p>
              {{ 'footer.tagline' | translate }}
            </p>
            <a
              href="https://www.instagram.com/actively.gr/"
              target="_blank"
              rel="noopener noreferrer"
              class="footer-social"
              [attr.aria-label]="'footer.instagramAria' | translate"
            >
              <i class="pi pi-instagram" aria-hidden="true"></i>
              <span>Instagram</span>
            </a>
          </div>

          <!-- Discover column hidden for now (route still live); un-comment to restore
          <nav class="ap-footer__col" [attr.aria-label]="'footer.discover' | translate">
            <h5>{{ 'footer.discover' | translate }}</h5>
            <a routerLink="/discover">{{ 'footer.exploreClubs' | translate }}</a>
          </nav>
          -->

          <nav class="ap-footer__col" [attr.aria-label]="'common.forClubs' | translate">
            <h5>{{ 'common.forClubs' | translate }}</h5>
            <a routerLink="/partners">{{ 'footer.listFacility' | translate }}</a>
            <a routerLink="/contact">{{ 'footer.talkToUs' | translate }}</a>
          </nav>

          <nav class="ap-footer__col" [attr.aria-label]="'footer.company' | translate">
            <h5>{{ 'footer.company' | translate }}</h5>
            <a routerLink="/terms">{{ 'footer.terms' | translate }}</a>
            <a routerLink="/privacy">{{ 'footer.privacy' | translate }}</a>
            <a routerLink="/contact">{{ 'footer.contact' | translate }}</a>
          </nav>
        </div>

        <div class="ap-footer__bottom">
          <span class="ap-mono">&copy; {{ currentYear }} Actively</span>
          <span>{{ 'footer.motto' | translate }}</span>
        </div>
      </div>
    </footer>
  `,
  styles: [
    `
      :host {
        display: block;
      }
      .footer-social {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        margin-top: 16px;
        font-size: 14px;
        color: var(--ap-ink-2);
        text-decoration: none;
        transition: color 0.2s ease;
      }
      .footer-social:hover {
        color: var(--ap-green);
      }
    `,
  ],
})
export class FooterComponent {
  currentYear = new Date().getFullYear();
}
